import { CheckOutlined } from '@ant-design/icons';
import { Progress, Row, Spin, Typography } from 'antd';
import React from 'react';

import { EmergencyScenarioStatus, EmergencyScenarioSyncStatus } from '../../../../graphql/api/generated';
import { Color } from '../../../../utils';

import type { IEmergencyScenarioMonitoringProps } from './typings';

function getTotalSyncStatuses(
  monitoredItems: { syncStatus: EmergencyScenarioSyncStatus; }[],
  syncStatus: EmergencyScenarioSyncStatus,
) {
  return monitoredItems.filter(i => i.syncStatus === syncStatus).length;
}

const PROGRESS_STATUSES_MAP: { [key in EmergencyScenarioSyncStatus]: string } = {
  [EmergencyScenarioSyncStatus.ERROR]: 'exception',
  [EmergencyScenarioSyncStatus.SUCCESS]: 'success',
  [EmergencyScenarioSyncStatus.WAITING]: 'active',
};

type EmergencyScenarioProgressMonitoringProps = IEmergencyScenarioMonitoringProps & {
  activeTab: string;
};

export const EmergencyScenarioProgressMonitoring: React.FC<EmergencyScenarioProgressMonitoringProps> = (props) => {
  const { emergencyScenarioMonitoring, activeTab } = props;
  const { monitoredAccessPoints, monitoredHubs, syncStatus } = emergencyScenarioMonitoring;
  const desiredStatus = emergencyScenarioMonitoring.emergencyScenario.status;

  const tabs = [
    {
      tabName: 'ACCESS_POINTS',
      pluralDisplayName: 'access points',
      monitoredItems:  monitoredAccessPoints,
    },
    {
      tabName: 'HUBS',
      pluralDisplayName: 'hubs',
      monitoredItems: monitoredHubs,
    },
  ];

  const activeTabInfo = tabs.find(t => t.tabName === activeTab);

  if (!activeTabInfo) {
    return null;
  }

  const { monitoredItems } = activeTabInfo;

  const totalSuccess = getTotalSyncStatuses(monitoredItems, EmergencyScenarioSyncStatus.SUCCESS);
  const totalError = getTotalSyncStatuses(monitoredItems, EmergencyScenarioSyncStatus.ERROR);
  const totalReported = totalSuccess + totalError;

  const totalMonitored = monitoredItems.length;
  const progressPercent = (totalReported / totalMonitored) * 100;
  const progressStatus = PROGRESS_STATUSES_MAP[syncStatus];

  return (
    <>
      <Typography.Paragraph style={{ textAlign: 'center' }}>
        {syncStatus === EmergencyScenarioSyncStatus.WAITING && <Spin style={{ marginRight: 8 }} />}
        {syncStatus === EmergencyScenarioSyncStatus.SUCCESS && (
          <CheckOutlined style={{ color: Color.Green, marginRight: 8}} />
        )}
        <strong>{totalSuccess}</strong> out of{' '}
        <strong>{totalMonitored}</strong> {activeTabInfo.pluralDisplayName}
        {desiredStatus === EmergencyScenarioStatus.INACTIVE ? ' deactivated' : ' activated'}
      </Typography.Paragraph>
      <Row style={{ marginBottom: 20 }}>
        <Progress
          showInfo
          percent={Math.floor(progressPercent)}
          status={progressStatus as any}
        />
      </Row>
    </>
  );
};
